export default "__VITE_ASSET__WmiRtg9K__"